import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import { useParams } from 'react-router-dom';
import VesselDetails from '../../components/vessels/general/details';

interface VesselDetailsPageProps {
}

const VesselDetailsPage: React.FC<VesselDetailsPageProps> = (props: VesselDetailsPageProps) => {
    const {topbar} = useStore();
    const params: any = useParams();

    useEffect(() => {
        topbar.show("Vessels", [
            {key: "home", icon: faHome, href: "/"},
            {key: "vessels", text: 'Vessels'}
        ]);
    }, []);

    return <Stack>
        <VesselDetails vesselId={params.vesselId} />
    </Stack>;
};

export default VesselDetailsPage;
